import React from 'react';
import { Link } from 'react-router-dom';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import HoverTableRow from '../../commonComponents/util/HoverTableRow';
import ApplicationStatusTag from '../../commonComponents/shared/ApplicationStatusTag';
import { formatCurrency, formatDate } from '../../../lib/utils';
import { CurrencyTypes, RecipientTypes } from '../../../lib/systemVariables';
import RecipientSummaryCard from '../../applicationsComponents/applications/RecipientSummaryCard';

export default class RecipientAccountsTableRow extends NavigationComponent {

    state = { summaryOpen: false };

    render() {
        const { applicantId, lastApplication, firstName, lastOrOrgName, addressDisplay, tags, applicantType, total, canBeDeleted, incomplete, 
                reportName, teudatZahut } = this.props.recipient;
        const tooltipText = reportName && reportName !== lastOrOrgName
            ? `${lastOrOrgName} - Report name: ${reportName}`
            : lastOrOrgName;

        return (
            <HoverTableRow className={`table-row ${this.state.summaryOpen ? 'recipient-summary-open' : ''}`} onClick={this.pushRouteWithProps.bind(this, `/recipient-accounts/${applicantId}`, { prevPage: 'Recipients' })}>
                <td data-label="Select">
                    <div className={`custom-check-container name-check-container ${!this.props.selected && !this.props.canSelect ? "disabled" : ""}`}>
                        <input type="checkbox" id={`select-${applicantId}`} className="custom-check input"
                            checked={this.props.selected} onChange={() => this.props.selectRecipient(this.props.recipient)}
                            disabled={!this.props.selected && !this.props.canSelect} />
                        <label htmlFor={`select-${applicantId}`} className="secondary-text input" />
                    </div>
                </td>
                <td data-label="FirstName">
                    <p>{firstName}</p>
                </td>
                <td data-label="Name" className="recipient-name-col">
                    <div className="recipient-name-layout">
                        <div className="bold-text recipient-name-content">
                            {applicantType === RecipientTypes.Organization
                                ? <i className={`material-icons accent-text3 middle recipient-name-icon ${incomplete ? 'disabled' : ''}`}>business</i>
                                : <i className={`material-icons accent-text2 middle recipient-name-icon ${incomplete ? 'disabled' : ''}`}>person</i>}
                            <Link className="recipient-name-link" to={`/recipient-accounts/${applicantId}`} title={tooltipText || undefined}>
                                {lastOrOrgName}
                            </Link>
                        </div>
                        <div className="recipient-name-actions">
                            {incomplete && <span className="tag incomplete">Incomplete</span>}
                            {this.props.canViewApplications && <RecipientSummaryCard recipientId={applicantId}
                                onOpenChange={summaryOpen => this.setState({ summaryOpen })}
                                title={`${firstName ? `${firstName} ` : ''}${lastOrOrgName || ''}`.trim()} />}
                        </div>
                    </div>
                </td>
                <td data-label="Address">
                    <p>{addressDisplay}</p>
                </td>
                {this.props.includeTeudatZahut &&
                    <td data-label="TeudatZahut">
                        <p>{teudatZahut}</p>
                    </td>}
                <td data-label="Category">
                    <p>{tags.join(' | ')}</p>
                </td>
                <td data-label="Last Application">
                    {lastApplication.applicationId && <div className="flex recipient-last-application-row">
                        <p><ApplicationStatusTag status={lastApplication.status} /></p>
                        <p>{formatCurrency(lastApplication.amount, lastApplication.currency === CurrencyTypes.Shekel)}</p>
                        <span className="accent-text recipient-last-application-date">{formatDate(lastApplication.date)}</span>
                    </div>}
                </td>
                <td data-label="Total" className="text-right">
                    <p>{total}</p>
                </td>
                {this.props.canDelete && <td data-label="Delete">
                    {canBeDeleted && <i className="icon-trash trash-hover input" onClick={this.props.delete}></i>}
                </td>}
            </HoverTableRow>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/recipientAccounts/RecipientAccountsTableRow.jsx